module.exports = __webpack_public_path__ + "img/language-select-binarystar.c7d3b2d0.svg";